import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/')({
  beforeLoad: () => {
    // Root resolves to the global Dashboard — the authed layout bounces
    // unauthenticated callers to /login.
    throw redirect({ to: '/dashboard' });
  },
});
